import React from "react";
import { addIntercomMsg, GET_NETWORK_ICON, isOnboardingPremiumNetwork } from "../../../../../../utils";
import { MediaBaseUrl } from "../../../../../../actions/api";

const SelectSourceTranscript = ({ selectedNetworkId, networkList, stepCompleted }) => {
    const activeNetworkId = selectedNetworkId || 2;
    const selectedNetwork = GET_NETWORK_ICON(activeNetworkId);
    const selectedNetworkName = networkList?.find(network => network.networkId == activeNetworkId)?.networkName || 'Instagram';

    return (
        <div className="mb-3 clearfix ob-step-block-1">
            <div className="ob-step-pill">Step 1</div>
            <div className="selectSource-chatbox mt-2">
                <div className="selectSource-list">
                    <p>Let's set up your Social Wall !</p>
                </div>
                <div className="selectSource-list">
                    <p>Select a social media platform to add content to your social wall.</p>
                </div>

                {(selectedNetworkId || stepCompleted >= 1) ? (
                    <div className="selectSource-list ob-network-bubble ob-user-bubble">
                        <p className="d-flex align-items-center justify-content-between gap-2 m-0">
                            <span>Oh, nice! You selected<br />{selectedNetworkName}. 🎉</span>
                            <img src={`${MediaBaseUrl}square-icons/${activeNetworkId == 1 ? 'twitterX' : selectedNetwork}.svg`} alt={selectedNetworkName} height="28" width="28" className="ob-network-bubble-icon flex-shrink-0 ms-2" />
                        </p>
                    </div>
                ) : null}

                {isOnboardingPremiumNetwork(selectedNetworkId) && !stepCompleted ? (
                    <div className="selectSource-list">
                        <p className="fb-hashtag-premium-msg">Great choice! 🎯 {selectedNetworkName} is a <strong>Premium feed source</strong> available exclusively on our <strong>Enterprise plan</strong>. <span className="cursor-pointer text-decoration-underline" onClick={() => addIntercomMsg(`Hi! 👋\nI'd like to collect content from ${selectedNetworkName} on my Social Wall.`)}>Chat with Us</span> to upgrade.</p>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default SelectSourceTranscript;
